import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";
import { generarImagenes } from "../../../../componentes/imprimir/GenerarImagenes";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda, formatoNumero } from "../../../../configuracion/validaciones";
import { ImprimirEnIframeCarta } from "../../../../componentes/imprimir/ImprimirEnIframeCarta";

export const ImprimirVenta = (venta, formato = 1) => {
  if (!venta) return;

  const {
    numeroFactura,
    Cliente,
    Empleado,
    ventadetallepedidos = [],
    ventadetallecita = [],
    descuento = 0,
    descuentoTercera = 0,
    exento = 0,
    exonerado = 0,
    importeImpuesto15 = 0,
    importeImpuesto18 = 0,
    impuesto15 = 0,
    impuesto18 = 0,
    totalVenta = 0,
    subtotal = 0,
    pagoVenta = [],
    rtn,
    facturas = [],
    recibos = [],
    creditos = [],
    createdAt
  } = venta;

  const items = [...ventadetallepedidos, ...ventadetallecita];

  const clienteNombreCompleto = Cliente?.nombreCorto || 'Consumidor Final';
  const empresaNombre = Cliente?.ClienteEmpresas?.[0]?.nombre;
  const empresaRtn = Cliente?.ClienteEmpresas?.[0]?.rtn;

  const rtnAImprimir =
    rtn ||
    Cliente?.rtn ||
    empresaRtn || "";

  let nombreAImprimir = clienteNombreCompleto;

  if (rtnAImprimir && rtnAImprimir === empresaRtn && empresaNombre && empresaNombre !== "") {
    nombreAImprimir = empresaNombre;
  }

  const pagosCompletados = pagoVenta?.map(pv => pv.pago).filter(p => p && p.estado !== 'Anulada') || [];
  const pago = pagosCompletados[pagosCompletados.length - 1] || {};
  const fechaHora = moment(createdAt || new Date()).format("DD-MM-YYYY HH:mm:ss");
  const recibido = parseFloat(pago.recibido || 0);
  const cambio = Math.max(recibido - parseFloat(totalVenta), 0);

  const efectivo =
    pago.pagoefectivos?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
  const transferencia =
    pago.pagotransferencia?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
  const tarjeta =
    pago.pagotarjeta?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;

  const factura = Array.isArray(facturas) && facturas.length > 0 ? facturas[0] : null;

  const facturacai = factura?.facturacai ?? null;
  const facturaNumero = factura?.numeroFactura ?? 0;
  const CAI = facturacai?.CAI ?? null;

  const recibo = Array.isArray(recibos) && recibos.length > 0 ? recibos[0] : null;

  const reciboNumero = recibo?.id ?? 0;
  const reciboSubtotal = parseFloat(subtotal + impuesto15 + importeImpuesto18 + descuento);

  const fechaLimiteFormateada =
    facturacai?.fechaLimite && moment(facturacai.fechaLimite).isValid()
      ? moment(facturacai.fechaLimite).format("DD/MM/YYYY")
      : null;

  const isFacturaDoc = facturas.length > 0;
  const isReciboDoc = recibos.length > 0;
  const isCreditoDoc = creditos.length > 0;

  const reciboId = isReciboDoc ? recibos[0]?.id : null;
  const creditoId = isCreditoDoc ? creditos[0]?.id : null;

  const tipoDocumento = isFacturaDoc
    ? "FACTURA"
    : isCreditoDoc
      ? "CREDITO"
      : "RECIBO";

  const numeroDocumento = isFacturaDoc
    ? "000-002-01-" + formatoNumero(facturaNumero)
    : isReciboDoc ?
      String(reciboNumero || "—") :
      "—";

  const numeroInicio = isFacturaDoc
    ? "000-002-01-" + formatoNumero(facturacai.numeroInicial)
    : String(venta?.id || "—");

  const numeroFin = isFacturaDoc
    ? "000-002-01-" + formatoNumero(facturacai.numeroFinal)
    : String(venta?.id || "—");

  const constanciaExonerado = facturas[0]?.facturaconstancia[0]?.numeroConstancia || null;
  const ordenCompraExenta = facturas[0]?.facturaexentos[0]?.numeroOrden || null;
  const registroSag = facturas[0]?.facturasags[0]?.numeroRegistro || null;

  const descuentoGlobal = parseFloat(descuento);


  let html = `
      <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
          <img src=${NegocioConfig.logo} style="width:150px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
        <div style="text-align:center; margin-bottom:5px;">
            <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
          <div style={{ fontSize: 12 }}>
            RTN: ${NegocioConfig.rtn}
          </div>
          <div style={{ fontSize: 12 }}>
            ${NegocioConfig.direccion}
          </div>
          <div style={{ fontSize: 12 }}>
            Tel: ${NegocioConfig.telefono}
          </div>
        <div style="font-weight:bold; margin:5px 0; text-align: left;">${tipoDocumento} No. ${numeroDocumento}</div>
         ${isReciboDoc && reciboId ? `<div style="text-align: left; font-size: 12px;">Recibo No: ${reciboId}</div>` : ""}
        ${isCreditoDoc && creditoId ? `<div style="text-align: left; font-size: 12px;">Crédito No: ${creditoId}</div>` : ""}
        ${isFacturaDoc
      ? `
            <div style="text-align: left;">CAI:</div>
            <div style="text-align: left;">${CAI}</div>
          `
      : ""
    }
        <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
        <div style="text-align: left;"><span>Atendió:</span> ${Empleado?.nombreCorto}</div>
      </div>
      <hr style="border:1px dashed black;" />
        <div><strong>Cliente:</strong> ${nombreAImprimir}</div>
        <div><strong>RTN:</strong> ${rtnAImprimir || 'N/A'}</div> 
        ${isFacturaDoc
      ? `
            <div style="font-size:12px; margin-top:5px; padding-top:5px;">
                <div style="font-weight:bold; font-size:13px; text-decoration:underline; margin-bottom:2px;">CERTIFICADOS</div>
                <div>Nº Constancia de Exonerado: ${constanciaExonerado || 'N/A'}</div>
                <div>Nº Orden de Compra Exenta: ${ordenCompraExenta || 'N/A'}</div>
                <div>Nº Registro de la SAG: ${registroSag || 'N/A'}</div>
            </div>
            `
      : ''
    }
        <hr style="border:1px dashed black;" />
        <div style="margin-top:5px;">
          ${items.map((item) => {
      const nombre = item.producto?.nombre || item.servicio?.nombre || "—";
      const codigo = item.producto?.codigo || item.servicio?.codigo || "—";
      const cantidad = parseFloat(item.cantidad || 0);
      const precioUnitario = isFacturaDoc ? parseFloat(item.precioSinImpuesto || 0) : parseFloat(item.precio || 0); // Precio final de venta
      const precioOriginal = parseFloat(item.precioOriginal || precioUnitario); // Precio de lista
      const descuentoItem = parseFloat(item.descuento || 0); // Descuento por ítem
      const subtotalMostrado = isFacturaDoc ? parseFloat(item.subtotalSinImpuesto || 0) : parseFloat(item.subtotal || 0); // Subtotal basado en el precio final de venta
      const mostrarDescuento = descuentoItem > 0 && precioOriginal > precioUnitario;

      return `
              <div style="margin-bottom:5px;">
                <div style="font-size:11px; margin-bottom:2px;">
                  ${codigo}
                </div>
                <div style="font-weight:bold; font-size:13px;">${nombre}</div>
                ${mostrarDescuento ?
          `<div style="font-size:11px; color:red; line-height:1.2;">
                      <span>DES: ${formatoMoneda(descuentoItem)}</span>
                    </div>`
          : ""}
                  
                <div style="display:flex; justify-content:space-between; font-size:12px;">
                  <span>${cantidad} x ${formatoMoneda(precioUnitario)}</span>
                  <span style="font-weight:bold;">${formatoMoneda(subtotalMostrado)}</span>
                </div>
              </div>`;
    }).join("")}
        </div>
        <hr style="border:1px dashed black;" />
        <div style="text-align:right;">
          <div>Subtotal Ítems: <strong>${isFacturaDoc ? formatoMoneda(subtotal) : formatoMoneda(reciboSubtotal)}</strong></div>

          ${descuentoGlobal > 0 ?
      `<div>Descuento / rebajas otorgadas: <strong>${formatoMoneda(descuentoGlobal)}</strong></div>`
      : ""}

          ${!isFacturaDoc
      ? `
              <div>Total a Pagar: <strong>${formatoMoneda(totalVenta)}</strong></div>
              <div>Total Recibido: <strong>${formatoMoneda(recibido)}</strong></div>
              ${efectivo > 0 ? `<div>Efectivo: <strong>${formatoMoneda(efectivo)}</strong></div>` : ""}
              ${tarjeta > 0 ? `<div>Tarjeta: <strong>${formatoMoneda(tarjeta)}</strong></div>` : ""}
              ${transferencia > 0 ? `<div>Transferencia: <strong>${formatoMoneda(transferencia)}</strong></div>` : ""}
              <div style="font-size:14px; font-weight:bold;">Cambio: ${formatoMoneda(cambio)}</div>
            `
      : `
              <div>Importe Exonerado: <strong>${formatoMoneda(exonerado)}</strong></div>
              <div>Importe Exento: <strong>${formatoMoneda(exento)}</strong></div>
              <div>Importe 15%: <strong>${formatoMoneda(importeImpuesto15)}</strong></div>
              <div>ISV 15%: <strong>${formatoMoneda(impuesto15)}</strong></div>
              <div>Importe 18%: <strong>${formatoMoneda(importeImpuesto18)}</strong></div>
              <div>ISV 18%: <strong>${formatoMoneda(impuesto18)}</strong></div>
              
              <div style="font-size:14px; font-weight:bold;">Total: ${formatoMoneda(totalVenta)}</div>
              <div style="margin-top:4px; margin-bottom:8px; font-weight:bold; font-size:12px; text-transform:uppercase;">
                ${NumeroALetras(totalVenta)}
              </div>
              <div>Total Recibido: <strong>${formatoMoneda(recibido)}</strong></div>
              ${efectivo > 0 ? `<div>Efectivo: <strong>${formatoMoneda(efectivo)}</strong></div>` : ""}
              ${tarjeta > 0 ? `<div>Tarjeta: <strong>${formatoMoneda(tarjeta)}</strong></div>` : ""}
              ${transferencia > 0 ? `<div>Transferencia: <strong>${formatoMoneda(transferencia)}</strong></div>` : ""}
              <div style="font-size:14px; font-weight:bold;">Cambio: ${formatoMoneda(cambio)}</div>
            `
    }
      </div>
      <div style="text-align:center; margin-top:20px; font-size:14px;">
        ${pago.documento === "FA" || isFacturaDoc
      ? ""
      : "<strong>¡Gracias por su compra!</strong>"}
        ${isFacturaDoc
      ? `
          <div style="margin-top: 10px;">
            <div>Rango Autorizado:</div>
            <div>${numeroInicio} al ${numeroFin} </div>
            <div>Fecha limite de emisión: ${fechaLimiteFormateada} </div>
          </div>
          `
      : ""
    }
      </div>
    </div>
    `;
  if (formato == 2)
    html = `
    <div style="width:800px; max-width: 100%; font-family:'Arial', sans-serif; font-size:12px; color:black; padding:20px; margin:0 auto; border: 1px solid #ccc;">
        <img src=${NegocioConfig.logo} style="width:150px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
        <div style="text-align:center; margin-bottom:15px;">
            <div style="font-weight:bold; font-size:24px; margin-bottom: 5px;">${NegocioConfig.nombre}</div>
            <div style="font-size: 14px; margin-bottom: 3px;">
                ${NegocioConfig.rtn}
            </div>
            <div style="font-size: 14px; margin-bottom: 3px;">
                ${NegocioConfig.direccion}
            </div>
            <div style="font-size: 14px;">
                Tel: ${NegocioConfig.telefono}
            </div>
        </div>

        <div style="border-bottom: 2px solid black; margin-bottom: 15px;"></div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
            <div style="width: 45%; font-size: 14px;">
                <div style="font-weight:bold; font-size:18px; margin-bottom: 8px;">${tipoDocumento} No. ${numeroDocumento} </div>
                ${isFacturaDoc
        ? `
            <div style="margin-bottom: 3px;">CAI: ${CAI}</div>
          `
        : ""
      }
                <div style="margin-bottom: 3px;">${fechaHora}</div>
                <div style="margin-bottom: 3px;">Atendió: ${Empleado?.nombreCorto}</div>
            </div>
            <div style="width: 45%; font-size: 14px;">
                <div style="font-weight:bold; font-size:16px; margin-bottom: 5px;">INFORMACIÓN DEL CLIENTE</div>
                <div style="margin-bottom: 3px;"><strong>Nombre:</strong> ${nombreAImprimir}</div>
                <div style="margin-bottom: 3px;"><strong>RTN Cliente:</strong> ${rtnAImprimir || 'N/A'}</div>
                 ${isFacturaDoc
        ? `
            <div style="margin-top:10px;">
                    <div style="font-weight:bold; font-size:14px; text-decoration:underline; margin-bottom:2px;">CERTIFICADOS</div>
                    <div>Nº Constancia de Exonerado: ${constanciaExonerado || 'N/A'}</div>
                    <div>Nº Orden de Compra Exenta: ${ordenCompraExenta || 'N/A'}</div>
                    <div>Nº Registro de la SAG: ${registroSag || 'N/A'}</div>
                </div>
            `
        : ''
      }
                
            </div>
        </div>

        <div style="border-bottom: 1px solid black; margin-bottom: 15px;"></div>

        <div style="font-weight:bold; font-size:16px; margin-bottom:10px;">DETALLE DE PRODUCTOS</div>
        
        <table style="width:100%; font-size:14px; border-collapse: collapse; margin-bottom:20px; border: 1px solid black;">
            <thead style="background-color: #f0f0f0;">
                <tr style="border-bottom: 2px solid black;">
                    <th style="text-align: left; padding: 5px 10px; width: 35%;">Descripción</th>
                    <th style="text-align: center; padding: 5px 10px; width: 15%;">Cant.</th>
                    <th style="text-align: right; padding: 5px 10px; width: 15%;">P. Unit.</th>
                    <th style="text-align: center; padding: 5px 10px; width: 15%;">Des.</th>
                    <th style="text-align: right; padding: 5px 10px; width: 20%;">Subtotal</th>
                </tr>
            </thead>
            <tbody>
                ${items.map((item) => {
        const nombre = item.producto?.nombre || item.servicio?.nombre || "—";
        const codigo = item.producto?.codigo || item.servicio?.codigo || "—";
        const cantidad = parseFloat(item.cantidad || 0);
        const precioUnitario = parseFloat(item.precioSinImpuesto || 0); // Precio final de venta
        const precioOriginal = parseFloat(item.precioOriginal || precioUnitario); // Precio de lista
        const descuentoItem = parseFloat(item.descuento || 0); // Descuento por ítem
        const subtotalMostrado = parseFloat(item.subtotalSinImpuesto || 0); // Subtotal basado en el precio final de venta
        const mostrarDescuento = descuentoItem > 0 && precioOriginal > precioUnitario;

        return `
                <tr style="border-bottom: 1px dashed #ccc;">
                    <td style="text-align: left; padding: 5px 10px;">${codigo} ${nombre}</td>
                    <td style="text-align: center; padding: 5px 10px;">${cantidad}</td>
                    <td style="text-align: right; padding: 5px 10px;">${formatoMoneda(precioUnitario)}</td>
                    <td style="text-align: right; padding: 5px 10px;">${formatoMoneda(descuentoItem)}</td>
                    <td style="text-align: right; padding: 5px 10px;">${formatoMoneda(subtotalMostrado)}</td>
                </tr>
             `;
      }).join("")}  
            </tbody>
        </table>

        <div style="display: flex; justify-content: flex-end;">
            <div style="width: 100%;">
                <table style="width:100%; font-size:14px; border-collapse: collapse; margin-bottom: 15px;">
                    <tr>
                        <td style="text-align: left; padding: 2px 0; width: 70%;">Subtotal items:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(subtotal)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Descuento:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(descuentoGlobal)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Importe Exonerado:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(exonerado)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Importe Exento:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(exento)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Importe 15%:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(importeImpuesto15)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Importe 18%:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(importeImpuesto18)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">ISV 15:%</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(impuesto15)}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">ISV 18:%</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(impuesto18)}</td>
                    </tr>
                    <tr style="font-size:16px; font-weight:bold; border-top: 1px solid black;">
                        <td style="text-align: left; padding: 5px 0;">TOTAL:</td>
                        <td style="text-align: right; padding: 5px 0;">${formatoMoneda(totalVenta)}</td>
                    </tr>
                </table>

                <div style="font-weight:bold; font-size:14px; text-transform:uppercase; text-align:center; margin-bottom: 20px; padding: 5px; border: 1px solid #ccc;">
                    ${NumeroALetras(totalVenta)}
                </div>
                
                <div style="font-weight:bold; font-size:16px; margin-bottom:5px;">DETALLE DE PAGO</div>
                <table style="width:100%; font-size:14px; border-collapse: collapse;">
                    <tr>
                        <td style="text-align: left; padding: 2px 0; width: 70%;">Total Recibido: ${formatoMoneda(recibido)}</td>
                        <td style="text-align: right; padding: 2px 0;"></td>
                    </tr>
                    ${efectivo > 0 ? `
                    <tr>
                        <td style="text-align: left; padding: 2px 0;">Efectivo:</td>
                        <td style="text-align: right; padding: 2px 0;">${formatoMoneda(efectivo)}</td>
                    </tr>
                    ` : ""}
                    ${tarjeta > 0 ? `
                    <tr style="font-size:16px; font-weight:bold; border-top: 1px solid black;">
                        <td style="text-align: left; padding: 5px 0;">Tarjeta:</td>
                        <td style="text-align: right; padding: 5px 0;">${formatoMoneda(tarjeta)}</td>
                    </tr>
                    ` : ""}
                    ${transferencia > 0 ? `
                    <tr style="font-size:16px; font-weight:bold; border-top: 1px solid black;">
                        <td style="text-align: left; padding: 5px 0;">Transferencia:</td>
                        <td style="text-align: right; padding: 5px 0;">${formatoMoneda(transferencia)}</td>
                    </tr>
                    ` : ""}
                    <tr style="font-size:16px; font-weight:bold; border-top: 1px solid black;">
                        <td style="text-align: left; padding: 5px 0;">Cambio:</td>
                        <td style="text-align: right; padding: 5px 0;">${formatoMoneda(cambio)}</td>
                    </tr>
                </table>
            </div>
        </div>
        
        <div style="border-bottom: 1px solid black; margin-top: 20px; margin-bottom: 15px;"></div>

        <div style="text-align:center; font-size:14px;">
            <strong style="display: block; margin-bottom: 15px;">¡Gracias por su compra!</strong>
             ${isCreditoDoc ? `
              <div style="margin-top: 50px; border-top: 1px solid black; width: 80%; margin-left: 10%; text-align: center;">
                <div style="font-size: 12px; margin-top: 5px;">Firma del Cliente</div>
              </div>
            ` : ""}
            ${isFacturaDoc
        ? `
            <div style="font-size:12px;">
                <div>Rango Autorizado: ${numeroInicio} al ${numeroFin}</div>
                <div>Fecha limite de emisión: ${fechaLimiteFormateada}</div>
            </div>
            `
        : ""
      }
            <div style="margin-top: 5px; font-size:12px;">
                Documento diseñado por DESOFIW
            </div>
        </div>
    </div>
`;

  ImprimirEnIframe(html, `Comprobante de Venta ${numeroDocumento}`, '5px');
  generarImagenes(html, 'Comprobante_Venta', numeroDocumento, 70);
  //const nombrePDF = `Comprobante_Venta_${numeroDocumento}.pdf`;
  //generarPDF(html, nombrePDF, 70);
};